import { render, staticRenderFns } from "./VehicleGuaranteeTab.vue?vue&type=template&id=c1b53bfa&scoped=true"
import script from "./VehicleGuaranteeTab.vue?vue&type=script&lang=js"
export * from "./VehicleGuaranteeTab.vue?vue&type=script&lang=js"
import style0 from "./VehicleGuaranteeTab.vue?vue&type=style&index=0&id=c1b53bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b53bfa",
  null
  
)

export default component.exports